import BaseModel from './base_model'

export default class CompanyModel extends BaseModel {

  constructor(record) {
    super()
    this.attributes = record
  }

  /**
   *  define
   */
  BIDDER_STATUS_COMPLETED = 100

  /**
   * isBidderStatusCompleted
   */
  isBidderStatusCompleted(){
    if(!this.attributes) return false
    return this.get('bidder_status') == this.BIDDER_STATUS_COMPLETED
  }

  /**
   * isIdExists?
   *   idの有無を確認する
   *   current_companyのidをチェックすることで、ログイン有無に代用
   */
  isIdExists() {
    return (this.attributes)? ('id' in this.attributes) : false
  }

}
